module.exports = __webpack_public_path__ + "static/media/James Stoddart.92df7c0c.png";